export default __webpack_public_path__ + "static/media/react-router-svg.2ead2a40.png";